<template>
  <label class="badge">{{label}}</label>
</template>

<script>
export default {
  name: 'Badge',
  props: {
    label: {
      type: String,
      default: ''
    }
  }
};
</script>

<style scoped lang="scss">
  @import "../style/color_";
  .badge {
    border-radius: 0.4em;
    font-size: 0.7em;
    font-style: normal;
    background-color:$color_primary;
    color: $color_initial;
    text-align: center;
    vertical-align: middle;
    display: inline-block;
    padding: 3px;
    margin: 0 1px;
  }
</style>
